 
 <style>
 textarea {
     width:100%;
     border-color:#d8d8d8;
 }
 </style>

<app-modal-header [headerTitle]="title" (languageSelected)="setSelectedLanguage($event)"></app-modal-header>
 
<div *ngIf="listsLoaded == true && item != null">

  <div mat-dialog-content>

  <div *ngIf="CurrentLocalizedData() != null" style="border-bottom:1px solid gray">
      {{currentLanguage.Name}}
  </div>

  <div *ngIf="CurrentLocalizedData() != null" class="languageContainer">

      <div class="form-group row">

        <div class="col-6">
            <div class="form-material">
                <input matInput Xplaceholder="Name" [(ngModel)]="CurrentLocalizedData().Name">
                <label for="">Name</label>
            </div>
        </div>

        <div class="col-6">
            <div class="form-material">
                <input matInput Xplaceholder="Spoken Name" [(ngModel)]="CurrentLocalizedData().AlternateName">
                <label for="">Recurrence Description</label>
            </div>
        </div>

        <div class="col-12">
            <div class="form-material">
                <textarea matInput Xplaceholder="Spoken Name" [(ngModel)]="CurrentLocalizedData().Description"></textarea>
                <label for="">Description</label>
            </div>
        </div>
        
  
      </div>
 
  </div>

 
  <div *ngIf="item.Id != undefined">
    <div style="border-bottom:1px solid gray">External Links</div>

    <div class="globalContainer">
        <div class="form-group">
            <app-calendar-item-edit-urls [calendarItem]="item" (linksUpdated)="reloadItem()"></app-calendar-item-edit-urls>
        </div>
    </div>
</div>

  <div style="border-bottom:1px solid gray">All Languages</div>

        <div class="globalContainer">

            <div class="row">

                <div class="col-6">
                    <div class="form-material">
        
                        <select [ngModel]="item.ReligionBranch?.Id"  (ngModelChange)="item.ReligionBranch = setModelValue($event, item.ReligionBranch)">
                            <option *ngFor="let section of religionBranches" [ngValue]="section.Id">
                                {{section.Name}}
                            </option>
                        </select>
        
                        <label for="">Religion Branch</label>
                    </div>
                </div>

                <div class="col-6">
                    <div class="form-material"> 
                        <div>
                            <select [(ngModel)]="item.RecurrenceType">
                                <option value=0>None</option>
                                <option value=4>Daily</option>
                                <option value=5>Weekly</option>
                                <option value=6>Monthly</option>
                                <option value=7>Yearly</option>
                                <option value=97>Attached to static Event/Holiday</option>
                                <option value=98>Attached to other Calendar Item</option>
                                <option value=99>Attached to Service</option>
                            </select>
                        </div>
                        <label for="">Recurrence Type</label>
                    </div>
                </div>
                
            </div>

 
  
            <div *ngIf="item.RecurrenceType < 97">
                <div class="row" >

                    <div class="col-6">
                        <div class="form-material"> 
                            <div><input type="text" matInput [ngModel]="item.StartDate | date:'MM/dd/yyyy'" (blur)="item.StartDate=$event.target.value"></div>
                            <label for="">Start Date</label>
                        </div>
                    </div>

                    <div class="col-6">
                        <div class="form-material"> 
                            <div><input type="text" matInput [ngModel]="item.EndDate | date:'MM/dd/yyyy'" (blur)="item.EndDate=$event.target.value"></div>
                            <label for="">End Date (for multi day events)</label> 
                        </div>
                    </div>

                </div>
            </div>
             
            <div *ngIf="item.RecurrenceType != 0 && item.RecurrenceType < 97">
                <div class="row" >
                    
                    <div class="col-3">
                        <div class="form-material"> 
                            <div><input type="number" matInput [(ngModel)]="item.MaxOccurrences"></div>
                            <label for="">Max Occurrences</label>
                        </div>
                    </div>

                    <div class="col-3">
                        <div class="form-material">  
                            <div><input type="number" matInput [(ngModel)]="item.RecurrenceInterval"></div> 
                            <label for="">Recurrence Interval</label>
                        </div>
                    </div>

                    <div class="col-3">
                        <div class="form-material"> 
                            <div><input type="text" matInput [ngModel]="item.RecurrenceEndDate | date:'MM/dd/yyyy'" (blur)="item.RecurrenceEndDate=$event.target.value"></div>
                            <label for="">Recurrence End Date</label>
                        </div>
                    </div>

                </div>

                <div class="row">
        
                    <div class="col-3">
                        <div class="form-material"> 
                            <div>
                                <select multiple [(ngModel)]="item.RecurrenceDayOfWeek" style="height: 150px;">
                                    <option [ngValue]=null></option>
                                    <option [ngValue]=0>Sunday</option>
                                    <option [ngValue]=1>Monday</option>
                                    <option [ngValue]=2>Tuesday</option>
                                    <option [ngValue]=3>Wednesday</option>
                                    <option [ngValue]=4>Thursday</option>
                                    <option [ngValue]=5>Friday</option>
                                    <option [ngValue]=6>Saturday</option>
                                </select> 
                            </div>
                            <label for="">RecurrenceDayOfWeek</label>
                        </div>
                    </div>
                    <div class="col-3">
                        <div class="form-material"> 
                            <div> 
                                <select [(ngModel)]="item.RecurrenceWeekOfMonth">
                                        <option [ngValue]=null></option> 
                                        <option [ngValue]=1>1</option>
                                        <option [ngValue]=2>2</option>
                                        <option [ngValue]=3>3</option>
                                        <option [ngValue]=4>4</option>
                                        <option [ngValue]=5>5</option> 
                                        <option [ngValue]=-1>Last</option> 
                                    </select> 
                            </div>
                            <label for="">RecurrenceWeekOfMonth</label>
                        </div>
                    </div>
                    <div class="col-3">
                        <div class="form-material"> 
                            <div><input type="number" matInput [(ngModel)]="item.RecurrenceDayOfMonth"></div>
                            <label for="">RecurrenceDayOfMonth</label>
                        </div>
                    </div>
                    <div class="col-3">
                        <div class="form-material"> 
                            <div>  
                                <select [(ngModel)]="item.RecurrenceMonthOfYear">
                                        <option [ngValue]=null></option> 
                                        <option [ngValue]=1>January</option>
                                        <option [ngValue]=2>February</option>
                                        <option [ngValue]=3>March</option>
                                        <option [ngValue]=4>April</option>
                                        <option [ngValue]=5>May</option>
                                        <option [ngValue]=6>June</option>
                                        <option [ngValue]=7>July</option>
                                        <option [ngValue]=8>August</option>
                                        <option [ngValue]=9>September</option>
                                        <option [ngValue]=10>October</option>
                                        <option [ngValue]=11>November</option>
                                        <option [ngValue]=12>December</option> 
                                    </select> 
                            </div>
                            <label for="">RecurrenceMonthOfYear</label>
                        </div>
                    </div>

                    <div class="col-3">
                        <div class="form-material"> 
                            <div> 
                                <select  multiple [(ngModel)]="item.IncludedInSeasons" [compareWith]="compareSeason" style="height: 150px;">
                                    <option [ngValue]=null></option>
                                    <option *ngFor="let season of seasons" [ngValue]="season">
                                        {{season.Localized[0].Name}}
                                    </option>
                                </select>
                            </div>
                            <label for="">Included In Season</label>
                        </div>
                    </div>

                    <div class="col-3">
                        <div class="form-material"> 
                            <div>
                                <select multiple [(ngModel)]="item.ExcludedFromSeasons" [compareWith]="compareSeason" style="height: 150px;">
                                    <option [ngValue]=null></option>
                                    <option *ngFor="let season of seasons" [ngValue]="season">
                                        {{season.Localized[0].Name}}
                                    </option>
                                </select>
                            </div>
                            <label for="">Excluded From Season</label>
                        </div>
                    </div>


                </div>
            </div>
 

            </div>
     
            <div class="row" *ngIf="item.RecurrenceType == 97">

                    <div class="col-12">
                        <div class="form-material"> 
                            <div>
                                <select [(ngModel)]="item.RecurrenceEvent">
                                        <option></option>  

                                            <option value=131>Anglican Communion Sunday</option>
                                            <option value=130>Election Day (USA)</option>
                                            <option value=132>Victoria Day (Canada)</option> 

                                            <optgroup label="Lunar Events">
                                                <option value=80>Buddha's Birthday</option>
                                                <option value=81>Lunar New Year</option> 
                                            </optgroup>  

                                        <optgroup label="Jewish Events">  
                                                <option value=42>Chanukah</option>
                                                <option value=14>Erev Pesach</option>
                                                <option value=7>Erev Purim</option>
                                                <option value=30>Erev Rosh Hashana</option>
                                                <option value=22>Erev Shavuot</option>
                                                <option value=36>Erev Sukkot</option>
                                                <option value=34>Erev Yom Kippur</option>
                                                <option value=20>Lag BaOmer</option>
                                                <option value=29>Leil Selichot </option>
                                                <option value=15>Pesach</option>
                                                <option value=19>Pesach Sheni</option>
                                                <option value=8>Purim</option>
                                                <option value=3>Purim Katan</option>
                                                <option value=31>Rosh Hashana </option>
                                                <option value=25>Shabbat Chazon </option>
                                                <option value=11>Shabbat HaChodesh </option>
                                                <option value=12>Shabbat HaGadol </option>
                                                <option value=28>Shabbat Nachamu </option>
                                                <option value=10>Shabbat Parah </option>
                                                <option value=4>Shabbat Shekalim</option>
                                                <option value=33>Shabbat Shuva </option>
                                                <option value=5>Shabbat Zachor</option>
                                                <option value=23>Shavuot </option>
                                                <option value=38>Shmini Atzeret </option>
                                                <option value=9>Shushan Purim</option>
                                                <option value=41>Sigd </option>
                                                <option value=39>Simchat Torah </option>
                                                <option value=37>Sukkot </option>
                                                <option value=13>Taanit Bechorot </option>
                                                <option value=6>Taanit Esther</option>
                                                <option value=26>Tisha BAv </option>
                                                <option value=27>Tu BAv </option>
                                                <option value=2>Tu BiShvat</option>
                                                <option value=32>Tzom Gedaliah </option>
                                                <option value=24>Tzom Tammuz </option>
                                                <option value=18>Yo HaAtzmaut </option>
                                                <option value=40>Yom HaAliyah </option>
                                                <option value=16>Yom HaShoah </option>
                                                <option value=17>Yom HaZikaron </option>
                                                <option value=35>Yom Kippur </option>
                                                <option value=21>Yom Yerushalayim </option>
                                        </optgroup>  
                                        <optgroup label="Islamic Events">
                                            <option value=100>Ramadan</option>
                                            <option value=101>Eid Al Fitr</option>
                                            <option value=104>Eid Al Adha</option>
                                            <option value=105>Al Hijra Muharram</option>
                                            <option value=107>Mawlid Al Nabi</option> 
                                        </optgroup>  
                                </select>
                            </div>
                            <label for="">Event/Holiday</label>
                        </div>
                    </div>
    
                </div> 


            <div class="row" *ngIf="item.RecurrenceType == 98">
 
                    <div class="col-6">
                        <div class="form-material"> 
                            <div><input type="text" matInput [(ngModel)]="item.RecurrenceCalendarItemId"></div>
                            <label for="">Calendar Item Id</label>
                        </div>
                    </div>
 
                    <div class="col-6">
                        <div class="form-material"> 
                            <div><input type="number" matInput [(ngModel)]="item.RecurrenceCalendarItemOffsetInDays"></div>
                            <label for="">Number of days offset</label> 
                        </div>
                    </div> 
            </div>
    

            <div class="row" *ngIf="item.RecurrenceType == 99">

                <div class="col-12">
                    <div class="form-material"> 
                        <!-- <div><app-service-edit-related-service-lookup [defaultServiceName]="recurringServiceName" (serviceSelected)="serviceSuggestSelected($event)"></app-service-edit-related-service-lookup></div> -->
                        
                         <!-- <div><input type="text" matInput [(ngModel)]="item.RecurrenceServiceId"></div> -->
                        <!-- <label for="">Recurrence Service Id</label>
  -->
                        <app-calendar-item-edit-related-services [title]="'Related Services'" (servicesChanged)="detectAssignedServiceChanges($event)" [serviceIds]="assignedServices" [isExcluded]=false></app-calendar-item-edit-related-services>
                    </div>
                </div>

            </div>

            <div class="row">
                  
                <div class="col-12" *ngIf="item.Id != null">
                    <div class="form-material">  
                        <app-calendar-item-edit-related-services [title]="'Excluded From Services'" (servicesChanged)="detectExcludedServiceChanges($event)" [serviceIds]="excludedServices" [isExcluded]=true></app-calendar-item-edit-related-services>
                    </div>
                </div>
                 
            </div>

     
        <div style="border-bottom:1px solid gray">Calendar Item Id</div>

        <div class="globalContainer">
            <div>{{item.Id}}</div>
        </div>

    </div> 

 

  <div mat-dialog-actions class="float-right">

    <button mat-button (click)="cancel()" class="btn btn-sm btn-outline-secondary" style="margin-right:10px">Cancel</button>
    <button mat-button (click)="save()"   class="btn btn-sm btn-outline-primary">Save</button>

  </div>

</div>

<div *ngIf="listsLoaded == false || item == null">
    <p class="text-center">
            One moment please
    </p>
</div>
 